export const validateIsRelativeDate = (date: string) => {
  const relDateRegex = /^[0-9]*[yMwdHhms]$/;
  if (date) {
    return (
      date.includes('{{') ||
      date.split('/').every((term) =>
        term.split(/[-+]/).every((token) => {
          switch (token) {
            case 'now':
              return true;
            default:
              return token.match(relDateRegex);
          }
        }),
      )
    );
  }
  return false;
};
